import { LoadingState } from '../../../shared/ui/LoadingState.jsx';
import { DororaidIcon } from '../../../shared/ui/DororaidIcon.jsx';
import { useRaidTetris } from '../../raid-tetris/hooks/useRaidTetris.js';
import { RaidStrategyBoardPane } from '../../raid-tetris/shared/RaidStrategyPage.jsx';
import '../../../styles/raid-strategy-site-alignment.css';
import '../../../styles/raid-control-strategy-panel.css';
import '../../../styles/raid-control-strategy-density.css';

export function RaidControlStrategyPanel({ mobile = false, onClose = null }) {
  const tetris = useRaidTetris();

  return <section className={`raid-control-strategy-panel ${mobile ? 'mobile' : 'desktop'}`} aria-label="관제 계획표">
    <header className="raid-control-strategy-panel-head">
      <div><span>RAID PLAN</span><strong>계획표</strong></div>
      {onClose ? <button type="button" className="ui-icon-action close" onClick={onClose} aria-label="채팅으로" title="채팅으로"><DororaidIcon name="close" size={20} /></button> : null}
    </header>
    {tetris.loading ? <LoadingState label="계획표 동기화 중" variant="boss" count={5} />
      : tetris.errorMessage ? <div className="raid-control-strategy-panel-state error"><strong>계획표를 불러오지 못했습니다.</strong><p>{tetris.errorMessage}</p><button type="button" onClick={() => tetris.refresh()}>다시 시도</button></div>
      : !tetris.selectedSeason ? <div className="raid-control-strategy-panel-state"><strong>표시할 레이드 차수가 없습니다.</strong></div>
      : <RaidStrategyBoardPane mobile={mobile} tetris={tetris} embedded />}
  </section>;
}
